module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.currentFarm.lastIndicators[0].timelapse) ? _c('div', {
    staticClass: "timelapse"
  }, [_c('video-player', {
    ref: "videoPlayer",
    attrs: {
      "options": _vm.playerOptions
    },
    on: {
      "pause": function($event) {
        _vm.onPlayerPause($event)
      }
    }
  }), _c('div', {
    staticClass: "timelapse__desc"
  }, [_c('div', {
    staticClass: "timelapse__wrapper"
  }, [_c('div', {
    staticClass: "timelapse__desc-title"
  }, [_vm._v(_vm._s(_vm.getDate))]), _c('div', {
    staticClass: "timelapse__desc-subtitle"
  }, [_vm._v(_vm._s(_vm.currentFarm.config.location.label))])])])], 1) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-654cc3f2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-654cc3f2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timelapse/TimelapseComponent.vue
// module id = 825
// module chunks = 0